<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-row
          v-if="fetcherAdminGlobalCountsLoaded"
          class="global-counts"
        >
          <div
            v-for="(countItem, key) in fetcherAdminGlobalCounts"
            :key="key"
          >
            <span class="count-key">
              {{ key }}
            </span>: <span class="count">
              {{ countItem }}
            </span>
          </div>
        </b-row>

        <div v-if="fetcherAdminLogsLoaded">
          <b-tabs
            v-model="tabIndex"
            no-key-nav
          >
            <template v-for="(logItems, logType) in fetcherAdminLogs">
              <b-tab
                v-if="logItems.length > 0 || alwaysVisibleLogs.includes(logType)"
                :key="logType"
                @click="scrollToBottom(logType)"
              >
                <template slot="title">
                  {{ logType.replace("Log", "") }} <b-badge :class="`${(logItems.length > 0 && logItems[logItems.length-1].timestamp + messagesRecentFor) > now ? 'recent' : ''}`">
                    {{ logItems.length }}
                  </b-badge>
                </template>
                <ul
                  v-chat-scroll
                  :class="`console ${logType}`"
                >
                  <li
                    v-for="(message, key) in logItems"
                    :key="key"
                    :class="`${message.type} ${(message.timestamp + messagesRecentFor) > now ? 'recent' : ''}`"
                  >
                    <template v-if="IsObject(message.message)">
                      <span>{{ message.date }}</span>
                      <pre>{{ JSON.stringify(message.message, undefined, 2) }}</pre>
                    </template>
                    <template v-else>
                      <div>
                        {{ message.date }}
                        {{ JSON.stringify(message.message, undefined, 2) }}
                      </div>
                    </template>
                  </li>
                </ul>
              </b-tab>
            </template>
          </b-tabs>
        </div>
      </div>
    </MadModal>
  </div>
</template>

<script>
/* eslint-disable consistent-return */

import { mapState, mapActions } from 'vuex';
import { sync } from 'vuex-pathify';

import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {
  components: {
    MadModal: () => import('@/components/MadModal'),
  },

  mixins: [modalHelpers],

  data() {
    return {
      fetcherAdminLogsLoaded: false,
      fetcherAdminGlobalCountsLoaded: false,

      messagesRecentFor: 30,
      now: new Date().getTime() / 1000,

      alwaysVisibleLogs: [
        'jobLog', //
        'creatorLog',
        'postLog',
        'channelLog',
        'tagLog',
        'madLog',
        'messengerLog',
        'queueLog',
        'reportLog',
        'summaryLog',
      ],

      options: {
        width: '95%',
        height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminLogs: (state) => state.fetcherAdminLog.fetcherAdminLogs,
      fetcherAdminGlobalCounts: (state) => state.fetcherAdmin.fetcherAdminGlobalCounts,
    }),

    ...sync([
      'layout.tableStack', //
    ]),

    modalId() {
      return 'logs';
    },
  },

  created() {
    setInterval(() => {
      this.now = new Date().getTime() / 1000;
    }, 1000);
  },

  mounted() {
    // this.loadfetcherAdminLogs();
    this.loadFetcherAdminAllLogs();
    this.loadfetcherAdminGlobalCounts();
  },

  beforeDestroy() {
    this.$store.set('layout/tableStack', this.tableStack.filter((el) => el !== this.modalId));
  },

  methods: {
    ...mapActions([
      'getFetcherAdminLog', //
      'getFetcherAdminLogs',
      'getFetcherAdminGlobalCounts',
    ]),

    loadLogs() {
      Object.keys(this.fetcherAdminLogs).forEach((channel) => {
        this.loadFetcherAdminLog(channel);
      });
    },

    async loadFetcherAdminAllLogs() {
      try {
        await this.getFetcherAdminLogs();

        this.fetcherAdminLogsLoaded = true;
        // console.log('log.logs', this.fetcherAdminLogs);
      } catch (error) {
        console.log(error);
      }
    },

    async loadFetcherAdminLog(channel) {
      try {
        await this.getFetcherAdminLog({
          params: {
            channel,
          },
        });

        // console.log(`log.logs.${channel}`, this.fetcherAdminLogs[channel]);
      } catch (error) {
        console.log(error);
      }
    },

    async loadfetcherAdminGlobalCounts() {
      try {
        await this.getFetcherAdminGlobalCounts();

        this.fetcherAdminGlobalCountsLoaded = true;
        // console.log('fetcherAdminGlobalCounts', this.fetcherAdminGlobalCounts);
      } catch (error) {
        console.log(error);
      }
    },

    IsObject(str) {
      return str instanceof Object;
    },

    scrollToBottom(logType) {
      setTimeout(() => {
        $(`.console.${logType}`).scrollTop($(`.console.${logType}`)[0].scrollHeight);
      }, 100);
    },

    onOpened() {
      this.tableStack.push(this.modalId);
      this.modalOpened();
    },

    onClosed() {
      this.$store.set('layout/tableStack', this.tableStack.filter((el) => el !== this.modalId));
      this.modalClosed();
    },
  },
};
</script>

<style scoped>
.global-counts {
  padding: 0 15px 15px;
}

.global-counts span.count-key {
  text-transform: capitalize;
  font-weight: bold;
}

.global-counts span.count {
  padding-right: 10px;
}
</style>


<style lang="scss">
//colors
$red: red;
$black: #000;
$white: white;
$green_yellow: greenyellow;
$cyan_aqua: cyan;

.nav-tabs .nav-link {
  text-transform: capitalize;
  padding: 0.5rem 0.3rem;
}

.nav-tabs .nav-link .badge.recent {
  background: $green_yellow;
}

.console {
  height: 78vh;
  width: 100%;
  border-radius: 10px;
  border: 1px solid $black;
  overflow: scroll;
  background: $black;
  color: $white;
  padding: 5px 10px;

  li {
    list-style: none;
    font-weight: bold;

    &.recent,
    &.recent pre {
      color: $green_yellow;
    }

    &.info,
    &.info pre {
      color: $white;
    }

    &.error,
    &.error pre {
      color: $red;
    }
  }

  // .debug {
  //   color: Snow;
  // }

  // .info {
  //   color: LawnGreen;
  // }

  // .warn {
  //   color: GoldenRod;
  // }

  // .error {
  //   color: LightCoral;
  // }

  // pre code {
  //   font: 11pt/1.25 Monaco, monospace;
  // }
}
</style>
